import { user } from '@percept/redux/bundles'

import { get, noop } from 'lodash-es'

import { Middleware } from 'redux'


export type PartialStoreState<StoreState extends object> = Partial<{
  [K in keyof StoreState]: StoreState[K] extends object ? Partial<StoreState[K]> : StoreState[K] 
}>


const STATE_KEY = 'state'

export const REHYDRATE = 'REHYDRATE'
export const PERSIST = 'PERSIST'

let timeoutRef: NodeJS.Timeout | null = null
let isInitialLogin = true
let hasLoggedIn = false

export interface Persistence {
  selectDb(dbName: string): void
  get(key: string): Promise<unknown>
  set(key: string, value: unknown): Promise<unknown>
  drop(): Promise<unknown>
}

export type PersistenceMiddlewareConfig<StoreState extends object> = {
  persistence: Persistence
  serialize: (state: StoreState) => PartialStoreState<StoreState>
  dbNamePrefix?: string
  dropOnLogout?: boolean
}


export const persistenceMiddlewareCreator = <StoreState extends object>({
  persistence,
  serialize,
  dbNamePrefix = '',
  dropOnLogout = true,
}: PersistenceMiddlewareConfig<StoreState>): Middleware<{}, StoreState> => {

  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  return store => next => action => {

    if( action.type === PERSIST ){
      persistence.set(action.payload.key, action.payload).then(noop).catch(noop)
      return
    }

    if( user.utils.isLoginSuccessAction(action) ){

      hasLoggedIn = true
      const result = next(action)
      const userId = get(action.payload, 'user_id', 'SSO_USER')

      if( isInitialLogin ){
        try{
          persistence.selectDb(`${dbNamePrefix}${userId}`)
          persistence.get(STATE_KEY).then( state => {
            if( state !== null ){
              store.dispatch({ type: REHYDRATE, payload: { state } })
            }
          }).catch(noop)
        }catch(e){ noop() }
      }

      isInitialLogin = false
      return result

    }else if( dropOnLogout && action.type === user.actions.USER_LOGOUT ){
      try{
        persistence.drop().then(noop)
      }catch(e){ noop() }

    }else if( hasLoggedIn ){
      timeoutRef && clearTimeout(timeoutRef)
      timeoutRef = setTimeout(() => {
        try{
          const dump = serialize(store.getState())
          persistence.set(STATE_KEY, dump)
        }catch(e){ noop() }
      }, 1000)

    }

    return next(action)

  }

}
